var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoggedIn)?_c('div',{staticClass:"mai-wrapper"},[_c('theme-header'),_vm._v(" "),_c('div',{staticClass:"main-content container"},[_c('message-boxes'),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('theme-footer')],1):_c('login-page'),_vm._v(" "),_c('modals-container'),_vm._v(" "),_c('v-dialog')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c5785de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = LPfa
// module chunks = 32